import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './PaymentSuccess.scss';

const PaymentSuccess = () => {
    const { t } = useTranslation();
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div className="kanem-success-page">
            <div className="kanem-success-inner">
                <div className="kanem-success-icon">✓</div>
                <h1>{t('success.title')}</h1>
                <p>{t('success.desc')}</p>
                <div className="kanem-success-steps">
                    <div className="kanem-success-step">
                        <span>01</span>
                        <p>{t('success.step1')}</p>
                    </div>
                    <div className="kanem-success-step-line"></div>
                    <div className="kanem-success-step">
                        <span>02</span>
                        <p>{t('success.step2')}</p>
                    </div>
                    <div className="kanem-success-step-line"></div>
                    <div className="kanem-success-step">
                        <span>03</span>
                        <p>{t('success.step3')}</p>
                    </div>
                </div>
                <div className="kanem-success-actions">
                    <Link to="/" className="kanem-cta-btn">{t('success.cta')} →</Link>
                    <Link to="/contact" className="kanem-success-contact">{t('success.contact')}</Link>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;
